module.exports = __webpack_public_path__ + "static/media/camilo-santa-174.f7058fff.jpg";